import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import '@fontsource/zcool-qingke-huangyou'; // Defaults to weight 400 with normal variant.

ReactDOM.render(<App />, document.getElementById('root'));
